import { makeStyles, theme } from "cdh-data-portal-theme"

export const useStyles = makeStyles()(() => ({
  root: {
    alignItems: "center",
    backgroundColor: theme.colors.globalBackgroundLight,
    display: "flex",
    height: "100vh",
    justifyContent: "center",
    width: "100vw",
  },
  loginContainer: {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: 16,
  },
  subtitle: {
    "&&": {
      marginBottom: 8,
    },
  },
  title: {
    "&&": {
      color: theme.textColors.primary,
      margin: "16px 0 0 0",
    },
  },
}))
